module.exports = __webpack_public_path__ + "img/interaction-bar-search-kia.0c48a284.png";